import { render, staticRenderFns } from "./ConsultList.vue?vue&type=template&id=3530842a&scoped=true"
import script from "./ConsultList.vue?vue&type=script&lang=js"
export * from "./ConsultList.vue?vue&type=script&lang=js"
import style0 from "./ConsultList.vue?vue&type=style&index=0&id=3530842a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530842a",
  null
  
)

export default component.exports